// Register service worker + request permission
export async function initPushNotifications() {
  if (!('Notification' in window) || !('serviceWorker' in navigator)) return false;
  
  try {
    const reg = await navigator.serviceWorker.register('/nearme-sw.js');
    console.log('SW registered:', reg.scope);
    return true;
  } catch (e) {
    console.log('SW registration failed:', e);
    return false;
  }
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  
  const permission = await Notification.requestPermission();
  return permission === 'granted';
}

let lastNotifTime = {};

export function sendPushNotification({ senderId, senderName, message, onOpen }) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  
  // Anti-spam — max 1 notif par user toutes les 3 secondes
  const now = Date.now();
  if (lastNotifTime[senderId] && now - lastNotifTime[senderId] < 3000) return;
  lastNotifTime[senderId] = now;

  // Pas de notif si page active
  if (document.visibilityState === 'visible') return;

  const notif = new Notification(`nearme — ${senderName}`, {
    body: message.startsWith('[photo]') ? '📷 Photo' : message,
    icon: '/favicon.svg',
    badge: '/favicon.svg',
    tag: `msg-${senderId}`,
    renotify: true,
  });

  notif.onclick = () => {
    window.focus();
    if (onOpen) onOpen(senderId);
    notif.close();
  };

  setTimeout(() => notif.close(), 5000);
}
